// extracted by mini-css-extract-plugin
export default {"rating":"xB-z","numberOfStars":"yB-z","count":"zB-z","barGraphSpacing":"AB-z","barGraph":"BB-z"};